export default "__VITE_ASSET__DADX0MpB__"